import type { PanelProps } from "../panel-props"

import { openTextEditor } from "../../../write-code/source"
import { Button } from "../../button"
import { Row } from "../row.tsx"
import { SharedSettings } from "../shared-settings.tsx"

export function WriteCodeSettings({ closeSidebar }: PanelProps) {
  return (
    <SharedSettings closeSidebar={closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Editor</h3>
        <Row>
          <Button onClick={openTextEditor}>Change text</Button>
        </Row>
      </section>
    </SharedSettings>
  )
}
